<div *ngIf="mfaMethod === 'google_authenticator'">
  <div class=" p-0">
    <div class="d-flex flex-column align-items-center mt-2">
      <div class="text-center" style="margin-bottom: 2%; margin-top: 5%;">
        <p *ngIf="error" style="color: red">{{ errorMessage }}</p>
        <p *ngIf="!codeResent && !error">Open Google Authenticator app on your mobile device to get your verification
          code.</p>
        <p *ngIf="codeResent && !error" style="color: #5cb85c">We emailed you a new 6-digit code, please enter it to
          continue</p>
      </div>
      <form class="mb-5 mt-2">
        <div class="justify-content-center text-center row mb-2">
          <div class="col-form-input" style="padding: 1% 1%;">
            <p-checkbox [(ngModel)]="dontAskAgainChecked" binary="true" id="dontAskAgain"
                        name="dontAskAgain"></p-checkbox>
          </div>
          <label class="col-form-label text-right mb-2" for="dontAskAgain" style="padding-right: 1%">
            <b>Don't ask again on this device</b>
          </label>
        </div>
        <div style="width: 70%; margin: auto;">
          <code-input (codeChanged)="onSubmit($event)"
                      [codeLength]="6"
                      #codeInput
                      [isCodeHidden]="false">
          </code-input>
        </div>
        <div class="login-form-footer pt-5" style="font-size: 12px;">
          If you have lost access to your Google Authenticator app, please contact <a
          href="mailto:admin@mckay-brothers.com">admin&#64;mckay-brothers.com</a>
        </div>
      </form>
    </div>
    <div class="pull-right w-auto">
      <button (click)="cancel()" class="btn btn-sm btn-danger" type="button">
        <i aria-hidden="true" class="fa fa-sign-out"></i>
        log out
      </button>
    </div>
  </div>
</div>


<div *ngIf="mfaMethod === 'email'">
  <div class=" p-0">
    <div class="d-flex flex-column align-items-center mt-2">
      <div class="text-center mt-4 mb-4">
        <p *ngIf="error" style="color: red">{{ errorMessage }}</p>
        <p *ngIf="!codeResent && !error">We emailed you a 6-digit code, please enter it to continue</p>
        <p *ngIf="codeResent && !error" style="color: #5cb85c">We emailed you a new 6-digit code, please enter it to
          continue</p>
      </div>
      <form class="mb-5 mt-2">
        <div class="justify-content-center text-center row mb-3">
          <div class="col-form-input" style="padding: 1% 1%;">
            <p-checkbox [(ngModel)]="dontAskAgainChecked" binary="true" id="dontAskAgainEmail"
                        name="dontAskAgain"></p-checkbox>
          </div>
          <label class="col-form-label text-right" for="dontAskAgain" style="padding-right: 1%">
            <b>Don't ask again on this device</b>
          </label>
        </div>
        <div style="width: 70%; margin: auto;">
          <code-input (codeChanged)="onSubmit($event)"
                      (codeCompleted)="onSubmit($event)"
                      [codeLength]="6"
                      #codeInput
                      [isCodeHidden]="false">
          </code-input>
        </div>
        <div class="justify-content-center text-center" style="margin-top: 3%;">
          <a (click)="resendCode()" *ngIf="!resendCodeDisabled" style="color:#0062cc"><i class="fa fa-refresh"> </i>
            Resend code</a>
          <a *ngIf="resendCodeDisabled" class="disabled"><i class="fa fa-refresh"> </i> Resend code</a>
        </div>
        <div class="row justify-content-center mt-2">
          <p-button (onClick)="cancel()" label="Cancel"
                    styleClass="btn btn-primary btn-sm text-right"></p-button>
        </div>
      </form>
      <div class="login-form-footer">
        <p class="text-body " style="font-size: 10px;">
          Information accessed after log-in is confidential and proprietary to McKay Brothers, LLC ("McKay") and
          subject to the confidentiality agreement and Private Carrier Services Agreement between your company and
          McKay
          (collectively, the "Confidentiality Agreements"). <br>
          By logging in to the McKay website, you agree that information may not be accessed,
          used and disseminated except in compliance with the terms of the Confidentiality Agreements.
          <a [target]="'_blank'" [href]="privacyPolicyUrl"> Our Privacy Policy</a> applies
          to your use of this site.</p>
      </div>
    </div>
  </div>

</div>
